import { Row, Col, Typography, Button, Spin } from "antd";
import moment from "moment";
import { motion } from "framer-motion";

export default function DataItem({
  icon,
  iconColor,
  keyName,
  value,
  valueType,
  prefix,
  suffix,
  fieldWidth,
  hidden,
  button,
  buttonFunction,
  loading,
}) {
  // Format value based on type
  const formatValue = (val, type) => {
    if (!val) return <span style={{ color: "#888", marginLeft: "5px" }}>N/D</span>; // Subtle styling for "N/D"

    const formatters = {
      date: () => moment(val, "YYYY-MM-DD").format("DD/MM/YYYY"),
      time: () => val.substring(0, 5),
      integer: () => val.toLocaleString(),
      double: () => Number(val).toFixed(2).toLocaleString(),
      phone: () => val.replace(/\D/g, "").replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3"),
      email: () => val.toLowerCase(),
      string: () => val,
      longString: () => val,
    };

    return formatters[type] ? formatters[type]() : val;
  };

  const formattedValue = formatValue(value, valueType);
  const hasValue = value !== null && value !== undefined && value !== "";

  if (!hasValue && hidden) return null;

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.2 }}>
      <Row className="data-row">
        <Col span={fieldWidth} className="data-key">
          {icon && (
            <span
              style={{
                color: hasValue ? iconColor : "#bbb",
                marginRight: "5px",
                width: "25px",
                height: "25px",
                borderRadius: "50%",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                background: hasValue ? "rgba(0, 0, 0, 0.0)" : "rgba(0, 0, 0, 0.025)",
                border: hasValue ? "1px solid" : "1px solid rgba(0, 0, 0, 0.025)",
              }}
            >
              {icon}
            </span>
          )}
          <span>{keyName}</span>
        </Col>
        <Col span={24 - fieldWidth} className="data-value">
          {loading ? (
            <Spin size="small" />
          ) : (
            <>
              {hasValue && prefix && <span>{prefix}</span>}
              {formattedValue}
              {hasValue && suffix && <strong style={{ marginLeft: "5px" }}>{suffix}</strong>}
            </>
          )}
        </Col>
      </Row>

      {valueType === "longString" && (
        <Typography.Paragraph ellipsis={{ rows: 2, expandable: true, symbol: "Ver más" }} style={{ justifyContent: "left" }}>{formattedValue}</Typography.Paragraph>
      )}

      {button && (
        <Button type="primary" onClick={buttonFunction}>
          {button}
        </Button>
      )}
    </motion.div>
  );
}
